import * as React from 'react';
import { PrimaryButton, Link } from 'office-ui-fabric-react/lib/index';
import classnames from 'classnames'
import Wrapper from './Wrapper'
import { clientLog, apiLink, apiGetAccount } from '../util'
import { isIdTokenExpiredOrExpiring } from '../idToken'

export interface Props {
    error?: boolean;
    onDone: (account: any) => void;
    onReset: () => void;
    userIdentityToken: string;

}

export interface State {
    trying: boolean;
    pluginEmail?: string;
    // The identity token aged out while waiting: only a new sign-in helps
    expired?: boolean;
}

export default class Setup extends React.Component<Props, State> {
    constructor(props, context) {
        super(props, context);
        this.state = {
            trying: false,
            pluginEmail: undefined,
            expired: false
        };
    }

    async componentDidMount() {
        // Read the mailbox email we're running under
        try {
            const pluginEmail = (window as any).Office?.context?.mailbox?.userProfile?.emailAddress || undefined;
            if (pluginEmail && pluginEmail !== this.state.pluginEmail) {
                this.setState({ pluginEmail });
            }
        } catch { }
    }

    startChecking = async () => {
        setTimeout(this.doCheck, 2500);

    }

    doCheck = async () => {
        if (!this.state.trying) {
            return;
        }

        // Setup can take minutes, and this polls with the identity token the
        // add-in acquired at startup. Once that has aged out every poll is a
        // request the server can only answer with ReAuth, so stop and tell the
        // user rather than spin until the add-in is restarted.
        if (isIdTokenExpiredOrExpiring(this.props.userIdentityToken)) {
            clientLog("Identity token expired while waiting for set up to complete");
            this.setState({ trying: false, expired: true });
            return;
        }

        clientLog("Waiting for set up to complete");

        const pluginEmail = (window as any).Office?.context?.mailbox?.userProfile?.emailAddress;
        var linkResult = await apiLink(
            window.location.href,
            this.props.userIdentityToken,
            null,
            null,
            Office.context.mailbox.diagnostics.hostName,
            pluginEmail
        );

        if (linkResult.success && !linkResult.completeSetup) {

            var account = await apiGetAccount();

            if (account.setupComplete) {
                clientLog("Account set up is complete");
                this.setState({ trying: false });
                this.props.onDone(account);
            } else {
                if (this.state.trying) {
                    setTimeout(this.doCheck, 2500);
                }
            }
        } else {
            if (this.state.trying) {
                setTimeout(this.doCheck, 2500);
            }
        }

    }

    render() {
        const {
            error,
            userIdentityToken
        } = this.props;

        const {
            trying,
            pluginEmail,
            expired,
        } = this.state;

        return (
            <Wrapper
                account={null}
                className={classnames("mm-view mm-message mm-setup", { "-error": error })}>
                <p className="ms-font-xxl -title">Set up your account</p>
                {!trying ? <>
                    <p className="ms-font-l -message">Welcome to MailMerge365. Let's get you set up and ready to send your first campaign.</p>
                    <p className="ms-font-m -message">In order to schedule and send emails on your behalf, we are going to connect to your Office365 account and mailbox.</p>
                </> : <></>}

                {expired && <p className="ms-font-l -message">
                    Your sign-in expired while we were waiting for the set up to
                    finish. Sign in again to pick up where you left off.
                </p>}

                <div className="mm-para">
                    {expired && <PrimaryButton
                        onClick={() => this.props.onReset()}
                    >Sign in again</PrimaryButton>}
                    {!expired && !trying && <PrimaryButton
                        target="_blank"
                        href={"/login?setup=true"}
                        onClick={() => this.setState({ trying: true }, () => this.startChecking())}
                    >Connect with Microsoft 365</PrimaryButton>}
                    {!expired && trying && <PrimaryButton
                        target="_blank"
                        onClick={() => this.doCheck()}
                    >Waiting for set up to complete</PrimaryButton>}
                </div>


                {!trying && !expired ?
                    <p className="ms-font-s -message">Once you click the button a new page will open asking you to sign-in with your Microsoft 365 account.
                        When you've completed that step you can return to this window and start working with MailMerge365.</p>
                    :
                    (pluginEmail && <>
                        <p className="ms-font-l -message">
                            If you complete the setup but this window continues to
                            wait for setup to complete please ensure that the email
                            address you logged-in to Microsoft 365 was <strong>{pluginEmail}</strong>.
                        </p>
                        <p className="ms-font-s -message">
                            The email address selected as the "From" address when you start MailMerge365 determines
                            what user the Outlook app runs as and must match the account you sign-in during setup.
                            If you need to change it, close MailMerge365, change the From
                            address and then start MailMerge365 from the Outlook ribbon again.
                        </p>
                    </>
                    )}
                <p><a href="https://mm365.me/setup-plugin" target="_blank">More Information</a></p>

            </Wrapper>
        );
    }
}
